//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\
import { URLs } from 'src/environments/constants';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { ToolboxComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { LabelLayout } from 'echarts/features';
import { PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import html2canvas from 'html2canvas';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Data_Folder_RS_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Reports/Data_Folder_RS_FIN.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Router, ActivatedRoute } from '@angular/router';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';



@Component({
    selector: 'app-structured-repo-fin',
    templateUrl: './structured-repo-fin.component.html',
    styleUrls: ['./structured-repo-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/ReportStructuredGlobal.css'],
    standalone: false
})
export class StructuredRepoFINComponent implements OnInit {

  //+================== VARIABLES FOR TITLES ==================+\\
  public TitleTypeFIN: string = 'Generales';
  public CurrentLibrarySlug: string = 'fin';
  public CurrentLibraryName: string = 'Processes';
  public ItemLabel: string = 'Procesos';

  //+================== TYPE FIN ==================+\\
  public OptionsTypeFIN = [
    { value: 4, item: 'Generales' },
    { value: 1, item: 'Aprobados' },
    { value: 2, item: 'Pendientes' },
    { value: 3, item: 'Rechazados' },
  ];

  //+================== HEADERS ==================+\\
  public Header_Routes: string[] = ['raiz']; // variable to save route navigation


  //+================== VARIABLES FOR REPORTS ==================+\\
  public Folders_Nivel: Data_Folder_RS_FIN[] = [];
  public All_Files: number = 0;

  private Route_Level: string = '';
  public ValueTypeFIN: number = 4;


  //+================== VARIABLES FOR CHART ==================+\\
  public MyChart: any;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //-========================= SERVICES =========================-\\
  private Service_FIN = inject(LibraryFINService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private MasterLibraryService = inject(LibraryMasterService);

  ngOnInit(): void {

    echarts.use([
      ToolboxComponent,
      TooltipComponent,
      PieChart,
      CanvasRenderer,
      LabelLayout
    ]);

    var chartDom = document.getElementById('Pie_Chart')!;
    this.MyChart = echarts.init(chartDom);

    this.route.paramMap.subscribe(async params => {
      const slugFromRoute = (params.get('libSlug') || 'fin').toLowerCase();
      this.CurrentLibrarySlug = slugFromRoute;
      await this.LoadLibraryDisplayName(slugFromRoute);
      this.Load_Data(4, '');
    });

  }

  private async LoadLibraryDisplayName(slug: string): Promise<void> {
    try {
      if (slug === 'fin' || slug === 'processes') {
        this.CurrentLibraryName = 'Processes';
        this.ItemLabel = 'Procesos';
        return;
      }

      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      const library = (res.operation || []).find((item: any) => String(item?.Slug || '').toLowerCase() === slug);
      this.CurrentLibraryName = String(library?.Nombre || slug.toUpperCase());
      this.ItemLabel = 'Documentos';
    } catch {
      this.CurrentLibraryName = slug.toUpperCase();
      this.ItemLabel = 'Documentos';
    }
  }


  //&===================== FUNCTIONS FOR LOAD DATA SERVER =====================&\\

  private async Load_Data(Status: number, Path: string): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');


    try {


      const ResDataReport: Response_FIN = await firstValueFrom(this.Service_FIN.Report_Structured_FIN({ Path: Path, Status: Status, LibrarySlug: this.CurrentLibrarySlug }));

      if (ResDataReport.success) {

        if (ResDataReport.operation.Data_Folder.length === 0 && this.Header_Routes.length === 1) {

          Swal.fire({
            title: `Sin directorios en ${this.CurrentLibraryName}`,
            text: `¡Aún no existen directorios en la librería de ${this.CurrentLibraryName}!`,
            icon: 'info',
            confirmButtonColor: this.ColorConfirm,

          }).then(() => {

            this.router.navigate([`/Dashboard/General/SeeReportsCDMS`]);

          })

        } else if (ResDataReport.operation.Data_Folder.length === 0 && this.Header_Routes.length > 1) {

          Swal.fire({
            title: `No existen mas niveles dentro de esta carpeta`,
            text: '¿Desea ver el reporte listado del directorio seleccionado?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            confirmButtonText: '¡Sí, ver reporte!',
            cancelButtonText: 'No, Cancelar',
          }).then((result) => {

            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.SeeReportList();
            }
            this.BackFolder();
          })
        } else {

          this.Folders_Nivel = ResDataReport.operation.Data_Folder;
          this.All_Files = ResDataReport.operation.Counter_Files;

          this.Set_Data_To_Chart();

        }

      }

      Loader.classList.remove('active');
    } catch (e) {
      Loader.classList.remove('active');

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FORMAT DATA TO CHART ==================-\\
  private Set_Data_To_Chart(): void {


    let Data_Chart: any[] = [];

    for (const Folder of this.Folders_Nivel) {
      if (Folder.ALL_Files > 0) {
        Data_Chart.push({ value: Folder.ALL_Files, name: Folder.Name });
      }

    }

    this.Load_Chart(Data_Chart);
  }

  //-================== LOAD CHART OPTIONS AND DATA ==================-\\
  private Load_Chart(Data_Chart: any): void {

    const ScreenWidth = screen.width;


    let ChartScale: number = 200;

    if (ScreenWidth < 1280) {
      ChartScale = 145;
    } else if (ScreenWidth <= 1366) {
      ChartScale = 175;
    } else if (ScreenWidth <= 1920) {
      ChartScale = 200;
    }

    var option;

    option = {
      tooltip: {
        trigger: 'item'
      },

      color: ['#147496', '#1785AD', '#188FBA', '#1B9DCC', '#1CA5D6', '#21AEEB', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF', '#072834', '#0B3F52', '#0F5A75', '#147496', '#1785AD', '#188FBA', '#1B9DCC', '#1CA5D6', '#21AEEB', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF'],

      series: [
        {
          type: 'pie',
          radius: ['40%', ChartScale],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },

          emphasis: {
            label: {
              show: true,
              fontSize: 15,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          data: Data_Chart.sort(function (a: any, b: any) {
            return a.name - b.name
          })
        }
      ]
    };



    option && this.MyChart.setOption(option);


  }

  //&===================== END FUNCTIONS FOR LOAD DATA SERVER =====================&\\




  //&===================== FUNCTIONS FOR CARD OPTIONS =====================&\\


  //-================== TYPE REPORT FIN ==================-\\
  public ChangeTypeFIN(): void {
    this.TitleTypeFIN = (this.OptionsTypeFIN.find((item) => (item.value === this.ValueTypeFIN)))?.item!;
    this.Load_Data(this.ValueTypeFIN, this.Route_Level);
  }

  //-================== REPORT LIST TO LEVEL ==================-\\
  public SeeReportList(): void {
    if (this.CurrentLibrarySlug === 'fin' || this.CurrentLibrarySlug === 'processes') {
      window.open(`${URLs.URLINDEX}/Dashboard/FIN/ReportsLFIN/${this.ValueTypeFIN}/${encodeURIComponent(this.Route_Level === '' ? ('Root') : (this.Route_Level))}`);
    } else {
      window.open(`${URLs.URLINDEX}/Dashboard/Lib/${this.CurrentLibrarySlug}/ReportsLFIN/${this.ValueTypeFIN}/${encodeURIComponent(this.Route_Level === '' ? ('Root') : (this.Route_Level))}`);
    }
  }

  //-================== REPORT DOWNLOAD PDF ==================-\\
  public async DownloadReportPDF(): Promise<void> {

    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    ProgressModal.classList.add('active');

    try {

      const DataImg: FormData = await this.Capture_ScreenShot();

      const FileKey: string = await this.Send_ScreenShot(DataImg);

      const ResDownloadPDF: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_RS_PDF_FIN({ NameFileImg: FileKey, Path: this.Route_Level, Status: this.ValueTypeFIN, LibrarySlug: this.CurrentLibrarySlug }));

      if (ResDownloadPDF.success) {

        const URL: string = ResDownloadPDF.operation.URL;
        const File_Name: string = decodeURIComponent(URL).split('/').pop() || '';
        const Key_Files: string = ResDownloadPDF.operation.Key_Files;

        const File_Name_Download: string = `Report_Structured_${this.TitleTypeFIN}.${File_Name.split('.').pop()}`

        const IsDownload: boolean = await this.Download_File_FIN(URL, File_Name_Download);

        if (IsDownload) this.Delete_File_Temp_SR_FIN(File_Name, Key_Files)

      }


    } catch (e) {

      ProgressModal.classList.remove('active');
      Swal.fire({
        title: 'Error al descargar el reporte',
        text: `¡Ocurrió un error al descargar el reporte estructurado (PDF), inténtelo de nuevo, si el problema persiste notifique a su supervisor!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })
    }

  }

  //-================== FUNCTION FOR DOWNLOAD REPORT ==================-\\
  private async Download_File_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
      ProgressModal.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Reporte descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el reporte, informe a su supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  //-================== FUNCTION TO CAPTURE CHART ==================-\\
  private async Capture_ScreenShot(): Promise<FormData> {

    const options = {
      allowTaint: true,
      useCORS: true,
      backgroundColor: null,
    };

    const SectionSS = document.getElementById('Pie_Chart') as HTMLDivElement;

    const canvas = await html2canvas(SectionSS, options);
    const DataImg: string = canvas.toDataURL('image/png', 1);

    const response = await fetch(DataImg);
    const blob: Blob = await response.blob();

    const FormDataImg: FormData = new FormData();
    FormDataImg.append('FileSSR', blob, `Image.png`);

    return FormDataImg;
  }

   //-================== FUNCTION TO SEND CAPTURE CHART ==================-\\
  private async Send_ScreenShot(DataImg: FormData): Promise<string> {

    try {


      const ResUpdateSSR: Response_FIN = await firstValueFrom(this.Service_FIN.Upload_SSR_FIN(DataImg));

      const NameKey: string = ResUpdateSSR.operation.FileName;

      return NameKey;

    } catch (e) {

      throw "NO FILE NAME SSR";
    }

  }

   //-================== FUNCTION FOR DELETE FILE TEMP ==================-\\
  private async Delete_File_Temp_SR_FIN(File_Name_Delete: string, Key_Files: string): Promise<void> {
    try {

      const ResDelete: Response_FIN = await firstValueFrom(this.Service_FIN.Delete_RS_Temp_FIN({ Name_File: File_Name_Delete, Key_Files: Key_Files }));

      if (!ResDelete.success) {
        throw "ERROR DELETE TEMP";
      }

    } catch (e) {

      Swal.fire({
        title: 'Error al eliminar archivo temporal',
        text: `¡Ocurrió un error al eliminar archivo temporal del reporte generado, notifique a su supervisor el problema!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })

    }
  }

  //-================== REPORT DOWNLOAD XLSX ==================-\\
  public async DownloadReportXLSX(): Promise<void> {

    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    ProgressModal.classList.add('active');

    try {

      const DataImg: FormData = await this.Capture_ScreenShot();

      const FileKey: string = await this.Send_ScreenShot(DataImg);

      const ResDownloadXLSX: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_RS_XLSX_FIN({ NameFileImg: FileKey, Path: this.Route_Level, Status: this.ValueTypeFIN, LibrarySlug: this.CurrentLibrarySlug }));


      if (ResDownloadXLSX.success) {

        const URL: string = ResDownloadXLSX.operation.URL;
        const File_Name: string = decodeURIComponent(URL).split('/').pop() || '';
        const Key_Files: string = ResDownloadXLSX.operation.Key_Files;

        const File_Name_Download: string = `Report_Structured_${this.TitleTypeFIN}.${File_Name.split('.').pop()}`

        const IsDownload: boolean = await this.Download_File_FIN(URL, File_Name_Download);

        if (IsDownload)
          this.Delete_File_Temp_SR_FIN(File_Name, Key_Files)

      }


    } catch (e) {
      ProgressModal.classList.remove('active');
      Swal.fire({
        title: 'Error al descargar el reporte',
        text: `¡Ocurrió un error al descargar el reporte estructurado (excel), inténtelo de nuevo, si el problema persiste notifique a su supervisor!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })
    }

  }

  //-================== RELOAD PAGE ==================-\\
  public ReloadPage(): void {
    this.Load_Data(this.ValueTypeFIN, this.Route_Level);
  }

  //&===================== END FUNCTIONS FOR CARD OPTIONS =====================&\\



  //&===================== FUNCTIONS FOR GENERAL STRUCTURED REPORTS =====================&\\

  //-================== FUNCTION TO BROWSE DIRECTORIES ==================-\\
  public SeeFolder(Folder: Data_Folder_RS_FIN) {

    if (Folder.ALL_Files === 0) {
      Swal.fire({
        title: `No existen ${this.ItemLabel} ${this.TitleTypeFIN} en el directorio seleccionado`,
        text: `¡Los subdirectorios y el directorio seleccionado no contienen ${this.ItemLabel} ${this.TitleTypeFIN}!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: 'Ok',
      })
    } else {
      this.Route_Level = Folder.URL;

      const Header: string = this.Route_Level.split('/').pop()!;

      this.Header_Routes.push(Header);

      this.Load_Data(this.ValueTypeFIN, this.Route_Level);
    }

  }

  //-================== RETURN TO A ROUTE LEVEL ==================-\\
  public BackFolder(): void {
    let Route_String: string[] = this.Route_Level.split('/');
    Route_String.pop();

    this.Header_Routes.pop();

    this.Route_Level = Route_String.join('/');
    this.Load_Data(this.ValueTypeFIN, this.Route_Level);
  }

  //&===================== END FUNCTIONS FOR GENERAL STRUCTURED REPORTS =====================&\\

}
